<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input v-model="attribute.label" label="Name" v-uppercase />
      </div>
    </div>
    <base-button md type="primary" @click="onSubmit()">Save</base-button>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("attribute", ["attribute"])
    //...mapGetters({attribute:"attribute/getAttribute"})
  },

  methods: {
    ...mapActions({
      saveAttribute: "attribute/saveAttribute",
      updateAttribute: "attribute/updateAttribute",
      getAttributes: "attribute/getAttributes"
    }),

    onSubmit() {
      if (this.attribute.attributeId) {
        this.updateAttribute().then(res => {
          this.$notify({
            message: "Attribute Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getAttributes();
          this.$emit("close");
        });
      } else {
        this.saveAttribute().then(res => {
          this.$notify({
            message: "Attribute Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getAttributes();
          this.$emit("close");
        });
      }
    }
  }
};
</script>

